import React from 'react';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import { BodyContainer } from 'components/Containers/BodyContainer/BodyContainer';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import './InsuranceInfoForm.scss';
import { usePageView } from 'hook/helper.hook';
import { INSURANCE_PRE_FILL } from 'types/mrph.pageName.constants';
import { CollapsibleUpdateSection } from 'pages/Profile/pages/AccountSettings/components/PrimaryAccountSettingsViews';
import {
  Name,
  Address,
  PhoneNumber,
  Dob,
} from 'pages/Profile/pages/ProfileOverview/components/PersonalInfo';

const ContinuePrefillingContainer = props => {
  return (
    <FlexContainer className="flex-column justify-between margT40 format50 mformat100">
      <div className="Body-2 text-center">
        {'By continuing, you agree to have your data shared.'}
      </div>
      <Button
        datatestid={`${props?.datatestid}-auto-insurance-offer-get`}
        mrphType="primary"
        onClick={e => props?.onApplyClick(e, true)}
        className="margB12 margT8 text-14"
      >
        {'Continue'}
      </Button>
      <Label
        type="caption"
        color="fontBlue100"
        className="text-center margT10"
        bold
        datatestid={
          props?.datatestid ? `${props?.datatestid}-hideFilter` : null
        }
      >
        <span
          className="pointer text-14"
          onClick={e => props?.onApplyClick(e, false)}
          data-testid="aiHideFilter"
        >
          {'Continue without pre-filling'}
        </span>
      </Label>
    </FlexContainer>
  );
};

const UpdateInfoButton = props => {
  return (
    <FlexContainer className="flex-column justify-between margT40 format50 mformat100">
      <Button
        datatestid={`${props?.datatestid}-auto-insurance-offer-get`}
        mrphType="primary"
        onClick={props?.updatePrefillUserInfo}
        className="text-14"
      >
        {'Update'}
      </Button>
      <Label
        type="caption"
        color="fontBlue100"
        className="text-center margB40 margT22"
        bold
        datatestid={
          props?.datatestid ? `${props?.datatestid}-hideFilter` : null
        }
      >
        <span
          className="pointer text-14"
          onClick={props?.onCancelUpdatePrefill}
          data-testid="aiHideFilter"
        >
          {'Cancel'}
        </span>
      </Label>
    </FlexContainer>
  );
};

const ShowButtons = props => {
  let button = null;
  if (props?.isEdit) {
    button = <UpdateInfoButton {...props} />;
  } else {
    button = <ContinuePrefillingContainer {...props} />;
  }
  return button;
};

//TODO create own controller for autoinsuranceInfoForm , in order to build this need SLAPI details API , svc ticket to get approved.
const InsuranceInfoForm = props => {
  const datatestid = 'InsurancePrefillInfo';
  usePageView(false, { 'Page Name': INSURANCE_PRE_FILL });
  return (
    <BodyContainer className="insuranceForm">
      <PageContainer>
        <SectionContainer className="InsuranceContainer">
          <Row className="">
            <TitleContainer
              fullWidth
              type="pageTitle"
              className="marketplace-header margB8"
            >
              <Label type="H1" typeHeader={'h1'} className="margB8">
                {'Review your information'}
              </Label>
              <Label type="H6 mSubtitle-1">{`This information will be pre-filled for you when you continue to the insurance provider's website.`}</Label>
            </TitleContainer>
          </Row>

          <Row className="">
            <FlexContainer className="flex-column format50 mformat100">
              <Name
                firstName={props?.userInfo?.firstName}
                lastName={props?.userInfo?.lastName}
                readOnly
                classNameOverwrites={{
                  profileDataItem: {
                    profileDataItem:
                      'flex-column flex-mobile-col justify-between padT16 padB16',
                    title: {
                      desktopLabelType: 'Subtitle-1',
                      mobileLabelType: 'Subtitle-1',
                    },
                  },
                  displayView: {
                    view: 'format50 m-format100 margT12 m-margT4',
                  },
                }}
              />
              <Address
                addressForm={props?.addressForm}
                eventHandler={props?.eventHandler}
                hideButtons={true}
                isEditParent={props?.statesPrefill.isEditAddress}
                setIsEditParent={e =>
                  props?.setStatesPrefill({
                    isEditAddress: e,
                  })
                }
                classNameOverwrites={{
                  profileDataItem: {
                    profileDataItem:
                      'flex-column format100 ProfileDataItem flex-mobile-col justify-between padT16 padB16 pos-rel',
                    title: {
                      desktopLabelType: 'Subtitle-1',
                      mobileLabelType: 'Subtitle-1',
                    },
                  },
                  displayView: {
                    view: 'format50 m-format100 margT12 m-margT4',
                    editValue: '',
                  },
                  editView: {
                    editView: 'format100 margT12 m-format100 m-margT4',
                    editForm: {
                      container: 'format100',
                      stateZipContainer: 'flex-column',
                      separator: 'd-hide mobile-hide',
                    },
                  },
                }}
              />
              <PhoneNumber
                contactPhoneNumber={props?.phoneNumberInput?.contactPhoneNumber}
                phoneNumberInput={props?.phoneNumberInput}
                readOnly={false}
                eventHandler={props?.eventHandler}
                isEditParent={props?.statesPrefill.isEditPhone}
                setIsEditParent={e =>
                  props?.setStatesPrefill({
                    isEditPhone: e,
                  })
                }
                hideBlockError={true}
                overWriteTitle={'Phone number (optional)'}
                classNameOverwrites={{
                  profileDataItem: {
                    profileDataItem:
                      'flex-column ProfileDataItem flex-mobile-col justify-between padT16 padB16 pos-rel',
                    title: {
                      desktopLabelType: 'Subtitle-1',
                      mobileLabelType: 'Subtitle-1',
                    },
                  },
                  displayView: {
                    view: 'format50 m-format100 margT12 m-margT4',
                  },
                  edit: {
                    label: 'd-hide t-hide',
                  },
                  editView: {
                    editView: 'format100 margT12 m-format100 m-margT4',
                    editForm: {
                      container: 'format100',
                    },
                  },
                }}
                showUnMaskedPhoneNumber={true}
                quitTwo2faOauth={true}
                hideButtons={true}
              />
              <CollapsibleUpdateSection
                type="Email"
                profileEmail={props?.userInfo?.email}
                editEnabled={false}
                classNameOverwrites={{
                  profileDataItem: {
                    profileDataItem:
                      'flex-column format100 flex-mobile-col justify-between padT16 padB16',
                    title: {
                      desktopLabelType: 'Subtitle-1',
                      mobileLabelType: 'Subtitle-1',
                    },
                  },
                  displayView: {
                    view: 'format50 m-format100 margT12 m-margT4',
                    editValue: '',
                  },
                }}
              />
              <Dob
                dob={props?.userInfo?.birthDate}
                classNameOverwrites={{
                  profileDataItem: {
                    profileDataItem:
                      'flex-column flex-mobile-col justify-between padT16 padB16',
                    title: {
                      desktopLabelType: 'Subtitle-1',
                      mobileLabelType: 'Subtitle-1',
                    },
                  },
                  displayView: {
                    view: 'format50 m-format100 margT12 m-margT4',
                  },
                }}
              />
            </FlexContainer>
            <ShowButtons
              isEdit={props?.isEdit}
              datatestid={datatestid}
              {...props}
            />
          </Row>
        </SectionContainer>
      </PageContainer>
    </BodyContainer>
  );
};

export default InsuranceInfoForm;
